import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './create-mycar-valet.actions';
import { CreateMycarValetState } from './create-mycar-valet.state';

/**
 * createMycarValet initial state
 */
export const createMycarValetInitialState: CreateMycarValetState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for CreateMycarValet Store
 */
export const createMycarValetReducerFeatures: ReducerTypes<CreateMycarValetState, ActionCreator[]>[] = [
  on(actions.setCreateMycarValet, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCreateMycarValet, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCreateMycarValet, () => createMycarValetInitialState),

  on(actions.cancelCreateMycarValetRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCreateMycarValet, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setCreateMycarValetFromApi, actions.updateCreateMycarValetFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CreateMycarValet Store reducer
 */
export const createMycarValetReducer = createReducer(createMycarValetInitialState, ...createMycarValetReducerFeatures);
